var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    d: "M10 1.1L8.9 0 5 3.9 1.1 0 0 1.1 3.9 5 0 8.9 1.1 10 5 6.1 8.9 10 10 8.9 6.1 5z"
  })));
}
export default SvgX;